import { Link } from 'react-router-dom';
import './PublicSite.css';

export default function Home() {
  return (
    <div className="page home-page">
      <section className="hero">
        <div className="hero-image" style={{
          backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/233c16bd-c6cb-4f72-9afd-f013a1c1f7cc/images/1c92409fa415b6c6fd5be46f8989ea87cb927414928dd1b18dfbda6f0e25fc26.png')`
        }}>
          <div className="hero-overlay">
            <h1>Preserving the Course of Love</h1>
            <p className="hero-subtitle">A sanctuary for animals, humans, and consciousness itself</p>
            <div className="hero-cta">
              <Link to="/how-to-help" className="btn btn-primary">Support Our Mission</Link>
              <Link to="/about" className="btn btn-secondary">Learn More</Link>
            </div>
          </div>
        </div>
      </section>

      <section className="impact-stats">
        <div className="container">
          <div className="stat-grid">
            <div className="stat">
              <div className="stat-number">100%</div>
              <div className="stat-label">Integration Success Rate</div>
            </div>
            <div className="stat">
              <div className="stat-number">100+</div>
              <div className="stat-label">Animals Cared For</div>
            </div>
            <div className="stat">
              <div className="stat-number">1 Year</div>
              <div className="stat-label">Operating at Capacity</div>
            </div>
            <div className="stat">
              <div className="stat-number">60%</div>
              <div className="stat-label">Choose to Stay Forever</div>
            </div>
          </div>
        </div>
      </section>

      <section className="mission-section">
        <div className="container">
          <h2>Our Mission</h2>
          <p className="mission-statement">
            Sabbath Preservation Movement operates on one core principle: <strong>preservation of the course of love to instill symbiotic coexistence among all consciousness.</strong> This is not a religious doctrine but an ethical framework rooted in compassion, patience, love, and regenerative systems.
          </p>
          <p className="mission-tagline">Think <em>The Wild Robot</em> by Peter Brown—but real.</p>
        </div>
      </section>

      <section className="what-we-do">
        <div className="container">
          <h2>What We Do</h2>
          <div className="service-grid">
            <div className="service-card">
              <div className="service-icon">🐾</div>
              <h3>Animal Rehabilitation</h3>
              <p>We rescue animals facing euthanasia—particularly those labeled "aggressive," "unadoptable," or "too traumatized"—and integrate them successfully into environments with children, livestock, and adults.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🌱</div>
              <h3>Human Rehabilitation</h3>
              <p>We provide off-grid living education and holistic healing (plant-based medicine, sustainable practices) to individuals seeking self-sufficiency or recovery from illness.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">♻️</div>
              <h3>Sustainable Operations</h3>
              <p>Our off-grid sanctuary in Beatty, Oregon operates on regenerative principles: water recycling, cistern systems, solar power, and permaculture integration.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Join Our Mission</h2>
          <p>We're scaling compassion through innovation, sustainability, and love. Every animal deserves a chance. Every human deserves healing. Every consciousness deserves to thrive.</p>
          <Link to="/how-to-help" className="btn btn-primary btn-large">How You Can Help</Link>
        </div>
      </section>
    </div>
  );
}